import { ConfigService,
         RessourcePathHelper,
         IAttachment,
         AttachmentTypeEnum,
         EmotionTypeFromString,
         AttachmentButtonEntity,
         AttachmentSatisfactionEntity,
         AttachmentFeedbackScoreEntity,
         AttachmentImageEntity,
         AttachmentUrlEntity,
         AttachmentEmotionEntity,
         AttachmentButtonClarificationEntity }             from '../../..';

/**
 * The attachment factory is responsible of business logic related to 
 * attachment instantiation rules.
 */
export class AttachmentFactory { 

    /**
     * Returns a message entity.
     * 
     * @param msgAttachments - The message attachments list from bot answer
     * @param conversationId - The conversation identifier
     * @param watermark - The message watermark
     */
    public static buildMessageAttachmentsFromBotAnswer(msgId: string, msgAttachments: any[], watermark: number): Map<number, IAttachment[]> | undefined {
        if (!msgAttachments) { return; } 

        const attachments: Map<number, IAttachment[]> = new Map<number, IAttachment[]>();
        let counter: number = 0;

        msgAttachments.forEach((attachment: any) => {
            counter++;
            let attachEntity: IAttachment;
            const key: string = attachment.key;
            const buttons: AttachmentButtonEntity[] = [];

            switch(attachment.type) {

                case AttachmentTypeEnum.BUTTON:
                    attachEntity = new AttachmentButtonEntity(`${msgId}-${counter}`, key, attachment.text);
                    AttachmentFactory.addAttachment(attachments, attachEntity);
                    break;

                case AttachmentTypeEnum.SATISFACTION_QUESTION:
                    buttons.push(new AttachmentButtonEntity(    `${msgId}-${attachment.buttons[0].text}`, 
                                                                attachment.buttons[0].key,
                                                                attachment.buttons[0].text,
                                                                watermark,
                                                                attachment.buttons[0].finalMessage));

                    buttons.push(new AttachmentButtonClarificationEntity(   `${msgId}-${attachment.buttons[1].text}`, 
                                                                            attachment.buttons[1].key, 
                                                                            attachment.buttons[1].text,
                                                                            attachment.buttons[1].clarification,
                                                                            AttachmentFactory.buildClarificationButtons( attachment.buttons[1].clarificationOptions,
                                                                                                                         attachment.buttons[1].key,
                                                                                                                         `${msgId}-${attachment.buttons[1].text}` ),
                                                                            attachment.buttons[1].clarificationQuestion,
                                                                            watermark,
                                                                            attachment.buttons[1].finalMessage));

                    attachEntity = new AttachmentSatisfactionEntity(`${msgId}-${counter}`, key, attachment.text, buttons);
                    AttachmentFactory.addAttachment(attachments, attachEntity); 
                    break;

                case AttachmentTypeEnum.IMAGE:
                    attachEntity = new AttachmentImageEntity(`${msgId}-${counter}`, attachment.url);
                    AttachmentFactory.addAttachment(attachments, attachEntity);
                    break;

                case AttachmentTypeEnum.URL:
                    attachEntity = new AttachmentUrlEntity(`${msgId}-${counter}`, 
                                                            RessourcePathHelper.getAbsolutePath(ConfigService.getDocPathRootURL(), attachment.url),
                                                            ConfigService.getKnowMoreLinkLabel());
                    AttachmentFactory.addAttachment(attachments, attachEntity);
                    break;

                case AttachmentTypeEnum.EMOTION:
                    attachEntity = new AttachmentEmotionEntity(`${msgId}-${counter}`, EmotionTypeFromString[attachment.emotion]);
                    AttachmentFactory.addAttachment(attachments, attachEntity);
                    break;

                case AttachmentTypeEnum.FEEDBACK_SCORE:
                    attachEntity = new AttachmentFeedbackScoreEntity(`${msgId}-${counter}`);
                    AttachmentFactory.addAttachment(attachments, attachEntity);
                    break;
            }
        });
       
        return attachments;
    }

    /**
     * Build function for clarification button.
     * 
     * @param clarificationOptions - The clarification answers to display
     * @param key - The string which represent the "OK" or "Not OK" key
     * @param idSatisfaction - The string which represent the satisfaction object linked
     * 
     * @returns Array of AttachmentButtonEntity
     */
     private static buildClarificationButtons(clarificationOptions: any, key: string, idSatisfaction: string): AttachmentButtonEntity[] {
        const attButtonList: AttachmentButtonEntity[] = [];
        let i:number = 0;
        if (clarificationOptions && key) {
            clarificationOptions.forEach((clarificationOption:any) => {
                if (clarificationOption ) {
                    attButtonList.push(new AttachmentButtonEntity(idSatisfaction + "_clarif-btn-" + i++, key, clarificationOption));
                }
            });
        }
        return attButtonList;
    }

    /**
     * Build function to add the attachment entity to the given map.
     * 
     * @param attachments - The attachments map 
     * @param attachEntity - The attachment entity to add
     */
    private static addAttachment(attachments: Map<number, IAttachment[]>, attachEntity: IAttachment): void {
        if (!attachments.get(attachEntity.type)) {
            attachments.set(attachEntity.type, []);
        }
        const atts: IAttachment[] | undefined = attachments.get(attachEntity.type);
        if (atts) {
            atts.push(attachEntity);
        }
    }
}
